import { render, staticRenderFns } from "./Oravita.vue?vue&type=template&id=5ff24361&"
import script from "./Oravita.vue?vue&type=script&lang=js&"
export * from "./Oravita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports